(() => {
  if (window.leapColorGalleryInstalled) return;
  window.leapColorGalleryInstalled = true;

  const normalize = (value) => String(value || '').normalize('NFKC').trim().toLowerCase();
  const roles = {
    'トップス': 'top', 'トップスのカラー': 'top', 'top': 'top',
    'ボトムス': 'bottom', 'ボトムスのカラー': 'bottom', 'bottom': 'bottom',
    'gift': 'gift', 'ギフト': 'gift', '特典': 'gift',
    'カラー': 'color', '色': 'color', 'color': 'color'
  };

  // Use whole color names, so ホワイト never matches オフホワイト.
  const matchesColor = (alt, color, role) => {
    const requested = normalize(color);
    const tokens = normalize(alt).split(/[|,、;\n]+/).map((token) => token.trim());
    const tags = tokens.map((token) => {
      const colon = token.indexOf(':');
      return colon < 0 ? null : { role: roles[token.slice(0, colon).trim()], value: token.slice(colon + 1).trim() };
    }).filter((tag) => tag && tag.role);
    const scoped = tags.filter((tag) => tag.role === role);
    if (scoped.length) return scoped.some((tag) => tag.value === requested);
    // A photo tagged for a different garment must not be selected by accident.
    if (tags.some((tag) => tag.role !== 'color')) return false;
    return tags.some((tag) => tag.role === 'color' && tag.value === requested)
      || tokens.some((token) => token === requested || token.split(/\s+/).includes(requested));
  };

  const showColor = (input, scrollIntoView) => {
    const fieldset = input.closest('[data-leap-color-role]');
    const product = input.closest('product-info');
    const gallery = product?.querySelector('media-gallery');
    if (!fieldset || !gallery || typeof gallery.setActiveMedia !== 'function') return false;
    const media = Array.from(gallery.querySelectorAll('[data-leap-color-alt]'))
      .sort((a, b) => Number(a.dataset.mediaPosition) - Number(b.dataset.mediaPosition))
      .find((item) => matchesColor(item.dataset.leapColorAlt, input.value, fieldset.dataset.leapColorRole));
    if (!media) return false;
    gallery.setActiveMedia(media.dataset.mediaId, false, scrollIntoView);
    return true;
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-leap-color-role] input[type="radio"]') && event.target.checked) {
      showColor(event.target, true);
    }
  });

  const initialize = (root) => {
    const products = root.matches?.('product-info') ? [root] : root.querySelectorAll('product-info');
    for (const product of products) {
      for (const input of product.querySelectorAll('[data-leap-color-role] input:checked')) {
        if (showColor(input, false)) break;
      }
    }
  };
  customElements.whenDefined('media-gallery').then(() => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
